import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function forbiddenCharacters (forbiddenCharacters: string[]): ValidatorFn
{
    return (control: AbstractControl): ValidationErrors | null =>
    {
        const value = control.value || '';

        if (!forbiddenCharacters || forbiddenCharacters.length == 0)
        {
            return null;
        }

        for (const char of forbiddenCharacters)
        {
            if (value.indexOf(char) !== -1)
            {
                return {
                    'forbiddenCharacters': {
                        'forbiddenCharacters':  forbiddenCharacters.join(' ')
                    }
                };
            }
        }

        return null;
    };
}